import { WarningTriangleIcon } from "@xola/icons";
import { Alert, getSymbol } from "@xola/ui-kit";
import React from "react";
import { PaymentMethod, Seller, SellerPaymentMethod } from "types";
import { isOnFlexSubscription } from "../../../models/PartnerFeeFormula";

interface RefundOverMaxAllowedWarningProps {
    formAmount: number;
    maxAmount: number;
    seller: Seller;
    paymentMethod: SellerPaymentMethod | null;
    shouldReduce: boolean;
}

export const RefundOverMaxAllowedWarning = ({
    seller,
    formAmount,
    maxAmount,
    paymentMethod,
    shouldReduce,
}: RefundOverMaxAllowedWarningProps) => {
    const isStoreCredit = paymentMethod?.id === PaymentMethod.STORE_CREDIT;

    if (!shouldReduce && isStoreCredit && formAmount > maxAmount && isOnFlexSubscription(seller)) {
        return (
            <Alert className="flex-0 w-full" color="warning">
                <div className="alert-content-wrapper flex justify-between">
                    <WarningTriangleIcon size="large" className="mr-5 self-center" />
                    <p className="flex-1">
                        Refund to store credit is limited to a maximum of {getSymbol(seller.currency)}
                        <var data-var="maxAmount">{maxAmount}</var> for this booking.
                    </p>
                </div>
            </Alert>
        );
    }

    return null;
};
